// removed by extract-text-webpack-plugin
module.exports = {"block":"Breadcrumbs__block-2wL1H","item":"Breadcrumbs__item-PNU8T","title":"Breadcrumbs__title-2NN0a"};